import { render, staticRenderFns } from "./host-common-game.vue?vue&type=template&id=174425b6&scoped=true&"
import script from "./host-common-game.vue?vue&type=script&lang=js&"
export * from "./host-common-game.vue?vue&type=script&lang=js&"
import style0 from "./host-common-game.vue?vue&type=style&index=0&id=174425b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174425b6",
  null
  
)

export default component.exports